export default "__VITE_ASSET__Uy48n1AO__"